module.exports = __webpack_public_path__ + "static/media/SearchIcon.2086744a.svg";